import React from "react";

const educationContent = [
  {
    year: "2016 – 2020",
    degree: "COMPUTER SCIENCE",
    institute: "Landshut University of Applied Sciences",
    details: "Bachelor studies focused on software development, computer science fundamentals and practical engineering.",
  },
  {
    year: "2015- 2016",
    degree: "ACADEMIC GERMAN PREPARATION",
    institute: "AGI Sprachschule Stuttgart",
    details: "Advanced German language training focused on academic preparation and professional communication in Germany.",
  },
  {
    year: "2014- 2015",
    degree: "GERMAN LANGUAGE PROGRAM",
    institute: "Inlingua Sprachschule Stuttgart",
    details: "Intensive German language training as preparation for studying and working in Germany.",
  },/*
  {
    year: "2009",
    degree: "BACHELOR DEGREE ",
    institute: "TUNIS HIGH SCHOOL",
    details: `Lorem ipsum dolor sit amet, tempor incididunt ut laboreconsectetur
        elit, sed do eiusmod tempor duntt`,
  },*/
];

const Education = () => {
  return (
    <ul>
      {educationContent.map((val, i) => (
        <li key={i}>
          <div className="icon">
            <img src="img/about/education.png" alt="icon" />
          </div>
          <span className="time open-sans-font text-uppercase">{val.year}</span>
          <h5 className="poppins-font text-uppercase">
            {val.degree}
            <span className="place open-sans-font">{val.institute}</span>
          </h5>
          <p className="open-sans-font">{val.details}</p>
        </li>
      ))}
    </ul>
  );
};

export default Education;
